import axios from "axios";
import { CONFIG } from "../config";
import { configureSessionClient } from "./apiSession";

export default configureSessionClient(axios.create({
  baseURL: CONFIG.ACCOUNT_MANAGEMENT_HOST,
  headers: { Accept: "application/json", "Content-Type": "application/json" }
}));
